var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ModuleList from "@/components/widgets/list/moduleList";
import { useGetImportableModulesQuery } from "@/store/api";
import { useContext, useState } from "react";
import ImportWizardNavigation from "./importWizardNavigation";
import { ImportContext } from "./importWizard";
import { LoaderImage } from "@/utils/loader";
/**
 * Composant pour l'import des enregistrements
 * @param param0
 * @returns
 */
export default function Step1(_a) {
    var _b;
    var settings = _a.settings, goto = _a.goto;
    var _c = useGetImportableModulesQuery(null), moduleList = _c.data, isLoading = _c.isLoading;
    var modules = (moduleList && ((_b = moduleList === null || moduleList === void 0 ? void 0 : moduleList.data) === null || _b === void 0 ? void 0 : _b.modules)) || {};
    // Get ImportContext
    var importSettings = useContext(ImportContext);
    var _d = useState(importSettings.selectedModule), selectedValue = _d[0], setSelectedValue = _d[1];
    function getLevel(step) {
        settings.step = step;
        goto("Step".concat(step));
    }
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "" }, { children: [isLoading && _jsx(LoaderImage, {}), _jsx("div", __assign({ className: "" }, { children: _jsx("label", __assign({ className: "font-bold" }, { children: "Which module do you want to import data into?" })) })), _jsx("div", __assign({ className: "w-[340px] mt-4" }, { children: _jsx(ModuleList, { module: selectedValue, options: modules, onChange: function (event, v) {
                            setSelectedValue(v);
                            settings.selectedModule = v;
                        } }) })), _jsx(ImportWizardNavigation, { hasPrevious: false, hasNext: true, hasImport: false, previousEnabled: false, nextEnabled: false, importEnabled: false, level: getLevel })] })) }));
}
